import * as types from './actionTypes';  
import messageAddApi from '../api/messageAddApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doAddMessage(request) {

  return {
    type: types.DO_ADD_MESSAGE,
    request
    
  };
}

export function doAddMessageRes(data) {  
  return {
    type: types.DO_ADD_MESSAGE_RES, 
    data
  };
}

export function addMessage(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      messageAddApi.doAddMessage(request).then(data => {
        dispatch(doAddMessageRes(data));
        dispatch(doAddMessageRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}